/*
<!-- format number to currency default VND-->
<div v-currency="a_number"></div>
<div v-currency:usd="a_number"></div>
<div v-currency:sgd="a_number"></div>
<div v-currency:vnd="a_number"></div>
<div v-currency="{value: 132, currency: 'USD', precision: 2}"></div>
*/
const currencyDirective = {
  bind(el, binding) {
    const value = binding.value
    //
    let _currency = binding.arg || 'VND'
    let _precision = 0
    let _number = 0
    if (value && typeof value === 'object') {
      _currency = value.currency || _currency
      _precision = value.precision || _precision
      _number = value.value || _number
    } else {
      _number = value || 0
    }
    let html = `${_currency} ${parseFloat(_number).toFixed(_precision)}`
    if (_number && !isNaN(parseFloat(_number)) && isFinite(_number)) {
      html = _currency + ' ' + Number((Math.round(parseFloat(_number) * 100) / 100).toFixed(_precision)).toLocaleString()
    }
    el.innerHTML = html
  }
}

/**
 * <!-- input data is lower string -->
 * <input type="text" v-lower />
 */
const lowerDirective = {
  bind(el, binding, vnode) {
    el.addEventListener('blur', () => {
      el.value = el.value ? String(el.value).replace(/\s/g, '') : el.value
      vnode.elm.dispatchEvent(new CustomEvent('input'))
    })
  }
}

/**
 * <!-- input data is upper string -->
 * <input type="text" v-upper />
 */
const upperDirective = {
  bind(el, binding, vnode) {
    el.addEventListener('blur', () => {
      el.value = el.value ? String(el.value).toUpperCase() : el.value
      vnode.elm.dispatchEvent(new CustomEvent('input'))
    })
  }
}

const plugins = {
  install (Vue, alias = {}) {
    Vue.directive('currency', currencyDirective)
    Vue.directive('lower', lowerDirective)
    Vue.directive('upper', upperDirective)
    Vue.prototype.$__attr = function (key) {
      if (typeof key === 'string') {
        return Vue.$t(`attr.${key}`)
      } else {
        return Vue.$t(`attr.${key.value}`)
      }
    }
    Vue.mixin({
      methods: {
        __attr(key) {
          if (!key) {
            return '---'
          }
          if (typeof key === 'string') {
            return this.$t(`attr.${key}`)
          } else {
            return key.value ? this.$t(`attr.${key.value}`) : this.$t(key.text)
          }
        },

        __back(defaultName, e) {
          e.preventDefault()
          if (window.history.length > 1) {
            this.$router.go(-1)
          }
          this.$router.push({ name: defaultName })
        }
      }
    })
  }
}

export default plugins
